import {BoxProps, ElementProps, MantineSize, MantineColor, MantineRadius, Box} from '@mantine/core'
import React, {forwardRef} from 'react'
import {useSliderContext} from './slider'

export interface SliderRootProps extends BoxProps, ElementProps<'div'> {
  size?: MantineSize | (string & {}) | number
  children: React.ReactNode
  color?: MantineColor | undefined
  disabled: boolean | undefined
  variant?: string
  radius: MantineRadius | undefined
}

export const SliderRoot = forwardRef<HTMLDivElement, SliderRootProps>(
  ({size, disabled, variant, color, radius, ...others}: SliderRootProps, ref) => {
    const {getStyles} = useSliderContext()
    return <Box tabIndex={-1} variant={variant} size={size} ref={ref as any} {...getStyles('root')} {...others} />
  }
)

//@ts-ignore
SliderRoot.displayName = '@mantine/core/SliderRoot'
